import { render, staticRenderFns } from "./CreateCorpoAdminForm.vue?vue&type=template&id=475bf061&scoped=true"
import script from "./CreateCorpoAdminForm.vue?vue&type=script&lang=js"
export * from "./CreateCorpoAdminForm.vue?vue&type=script&lang=js"
import style0 from "./CreateCorpoAdminForm.vue?vue&type=style&index=0&id=475bf061&prod&lang=scss&scoped=true"
import style1 from "./CreateCorpoAdminForm.vue?vue&type=style&index=1&id=475bf061&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475bf061",
  null
  
)

export default component.exports